import { z } from "zod";

export const htmlPageSchema = z.object({
  id: z.string().optional(),
  name: z.string().min(1, "Name is required"),
  content: z.string().min(1, "Content is required"),
  organization: z.string().min(1, "Organization is required"),
});
